<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
export default {
    mounted() {

    }
}
</script>
<style src="../public/font/iconfont.css"></style>
<style src="../public/font/fonts/iconfont.css"></style>
<style lang="less">
#app{
    width: 100%;
    height: 100%;
}
</style>
